import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date/dateUtils';
import React from 'react';
export function ClaimTotalsRow(_ref) {
  let {
    ChangeHighlighter,
    FormattedNumberInput,
    claim
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement("div", null, "Current Claim Totals"), /*#__PURE__*/React.createElement("strong", null, createTimezonedDate(claim.from_date).toCustomLocaleDateString(), " - ", createTimezonedDate(claim.to_date).toCustomLocaleDateString()))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    object: claim,
    disabled: true,
    name: "employee_base_salary_total",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    object: claim,
    disabled: true,
    name: "employee_bonus_total",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    object: claim,
    disabled: true,
    name: "employee_national_insurance_total",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    object: claim,
    disabled: true,
    name: "employee_pension_total",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    object: claim,
    disabled: true,
    name: "employee_reimbursed_expenses_total",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    object: claim,
    disabled: true,
    name: "employee_net_amount",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    object: claim,
    disabled: true,
    name: "employees_capitalised_amount_total",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    object: claim,
    disabled: true,
    name: "employee_qualifying_rnd_expenditure",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    object: claim,
    disabled: true,
    name: "employees_pnl_expenditure_total",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    object: claim,
    disabled: true,
    name: "employees_s1308_total",
    type: "text",
    size: "sm"
  }))));
}